import {
  STOCK_GET_STOCK_BEGIN,
  STOCK_GET_STOCK_SUCCESS,
  STOCK_GET_STOCK_FAILURE,
  STOCK_GET_STOCK_DISMISS_ERROR,
} from './constants'
import axios from "axios"
import {REACT_APP_API} from '../../../common/config'

//Dato de prueba
/*const data = [
  {
    "id":"1",
    "idRefCatalogo":"0000001",
    "disponible":"FISICO", //FISICO, A DEUDA
    "idColor":"123123",
    "refPricing":"000001",
    "prioridad":true,
    "vin":"123456",
    "estado":"asdsa",
    "refAssets":[
        "54656876453",
        "54656876454",
        "54656876455"
    ],
    "ubicacion":"Cordoba",
    "certPago":"122443fdghgf",
    "origen":"A1",
    "sucursal":"Cordoba",
    "ingreso":[
        "2019"
    ],
    "egreso":[
        "2019"
    ],
    "valorToma":123,
    "puntajeComercial":"qwer",
    "lineasFinanc":[
        "345457667834","45656344234"
    ],
    "idPeritaje":[
        "345457667834","45656344234"
    ]
  },
  {
    "id":"2",
    "idRefCatalogo":"0000001",
    "disponible":"FISICO", //FISICO, A DEUDA
    "idColor":"123123",
    "refPricing":"000001",
    "prioridad":true,
    "vin":"123456",
    "estado":"asdsa",
    "refAssets":[
        "54656876453",
        "54656876454",
        "54656876455"
    ],
    "ubicacion":"Cordoba",
    "certPago": null,
    "origen":"A1",
    "sucursal":"Cordoba",
    "ingreso":[
        "2019"
    ],
    "egreso":[
        "2019"
    ],
    "valorToma":123,
    "puntajeComercial":"qwer",
    "lineasFinanc":[
        "345457667834","45656344234"
    ],
    "idPeritaje":[
        "345457667834","45656344234"
    ]
  },
  {
    "id":"3",
    "idRefCatalogo":"0000001",
    "disponible":"A DEUDA", //FISICO, A DEUDA
    "idColor":"123123",
    "refPricing":"000001",
    "prioridad":true,
    "vin":"123456",
    "estado":"asdsa",
    "refAssets":[
        "54656876453",
        "54656876454",
        "54656876455"
    ],
    "ubicacion":"Cordoba",
    "certPago":"122443fdghgf",
    "origen":"A1",
    "sucursal":"Cordoba",
    "ingreso":[
        "2019"
    ],
    "egreso":[
        "2019"
    ],
    "valorToma":123,
    "puntajeComercial":"qwer",
    "lineasFinanc":[
        "345457667834","45656344234"
    ],
    "idPeritaje":[
        "345457667834","45656344234"
    ]
  },
]*/

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getStock(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: STOCK_GET_STOCK_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API+'/stocks/referencia/'+args.id)
      doRequest.then(
        (res) => {
          dispatch({
            type: STOCK_GET_STOCK_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: STOCK_GET_STOCK_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetStockError() {
  return {
    type: STOCK_GET_STOCK_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_GET_STOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getStockPending: true,
        getStockError: null,
      };

    case STOCK_GET_STOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        getStockPending: false,
        getStockError: null,
        dataGetStock: action.data
      };

    case STOCK_GET_STOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        getStockPending: false,
        getStockError: action.data.error,
      };

    case STOCK_GET_STOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getStockError: null,
      };

    default:
      return state;
  }
}
